import React from 'react'
import './classification-banner.css'

const ClassificationBanner = () => {
    return(
        <>
           <div className="classification-banner" tabIndex={0} aria-label='Not for operational use'>NOT FOR OPERATIONAL USE.</div>
        </>
    )
}

export default ClassificationBanner